import { routes as ROUTES } from '../../../constants';

export const NAVIGATION_CONFIG = {
	industrial: [
		{
			type: 'default',
			href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.PRODUCTS}`,
			name: 'NAVIGATION.PRODUCTS',
			key: 'Products',
		},
		{
			type: 'default',
			href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.RENT}`,
			name: 'NAVIGATION.RENT',
			key: 'Rent',
		},
		{
			type: 'default',
			href: ROUTES.INDUSTRIAL.DOCUMENTS,
			name: 'NAVIGATION.DOCUMENTS',
			key: 'Documents',
		},
		{
			type: 'dropDown',
			href: '',
			name: 'NAVIGATION.NAVIGATION.ATEX_ASBEST',
			key: 'technieken',
			items: [{
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.ATEX}`,
				name: 'NAVIGATION.ATEX',
				key: 'atex',
			}, {
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.ASBEST}`,
				name: 'NAVIGATION.ASBEST_KWARTSSTOF',
				key: 'asbest',
			}],
		},
		{
			type: 'dropDown',
			href: '',
			name: 'NAVIGATION.ABOUT_US',
			key: 'about',
			items: [{
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.ABOUT_US}`,
				name: 'NAVIGATION.WHO_ARE_WE',
				key: 'who_are_we',
			}, {
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.CUSTOMIZATION}`,
				name: 'NAVIGATION.MAATWERK',
				key: 'maatwerk',
			}, {
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.REFERENCE}`,
				name: 'NAVIGATION.REFERENCES',
				key: 'References',
			}, {
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.PARTNERS}`,
				name: 'NAVIGATION.PARTNERS',
				key: 'Partners',
			}, {
				href: `${ROUTES.INDUSTRIAL.HOME}${ROUTES.PROJECTS}`,
				name: 'NAVIGATION.PROJECTS',
				key: 'Projects',
			}],
		},
		{
			type: 'default',
			href: ROUTES.INDUSTRIAL.CONTACT,
			name: 'NAVIGATION.CONTACT',
			key: 'contact',
		},
	],
	household: [
		{
			type: 'default',
			href: `${ROUTES.HOUSEHOLD.HOME}${ROUTES.PRODUCTS}`,
			name: 'NAVIGATION.PRODUCTS',
			key: 'Products',
		},
		{
			type: 'default',
			href: `${ROUTES.HOUSEHOLD.HOME}${ROUTES.REPAIRS}`,
			name: 'NAVIGATION.HERSTELLINGEN',
			key: 'Herstellingen',
		},
		{
			type: 'default',
			href: ROUTES.HOUSEHOLD.DOCUMENTS,
			name: 'NAVIGATION.DOCUMENTS',
			key: 'Documents',
		},
		{
			type: 'default',
			href: `${ROUTES.HOUSEHOLD.FAQ}`,
			name: 'NAVIGATION.FAQ',
			key: 'FAQ',
		},
		{
			type: 'dropDown',
			href: '',
			name: 'NAVIGATION.ABOUT_US',
			key: 'about',
			items: [{
				href: `${ROUTES.HOUSEHOLD.HOME}${ROUTES.ABOUT_US}`,
				name: 'NAVIGATION.WHO_ARE_WE',
				key: 'who_are_we',
			}, {
				href: `${ROUTES.HOUSEHOLD.HOME}${ROUTES.PARTNERS}`,
				name: 'NAVIGATION.PARTNERS',
				key: 'Partners',
			}],
		},
		{
			type: 'default',
			href: ROUTES.HOUSEHOLD.CONTACT,
			name: 'NAVIGATION.CONTACT',
			key: 'contact',
		},
	],
};



// WEBPACK FOOTER //
// ./src/components/molecules/navigation/navigation.config.js